/**
 * Store for managing selected payment method
 */
class StorePayment {
	constructor() {
		this.paymentMethod = null;
	}

	/**
	 * Set the active payment method
	 * @param {string} paymentMethod - Payment method ID
	 */
	setPaymentMethod(paymentMethod) {
		if (!paymentMethod) {
			console.warn('Invalid payment method ID');
			return;
		}
		this.paymentMethod = paymentMethod;
	}

	/**
	 * Get the current payment method
	 * @returns {string|null} Payment method ID or null
	 */
	getPaymentMethod() {
		return this.paymentMethod;
	}

	/**
	 * Clear the stored payment method (e.g. after payment failure)
	 */
	clearPaymentMethod() {
		this.paymentMethod = null;
	}
}

const storePayment = new StorePayment();
export { storePayment };
